import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Chip,
  Divider,
  Box,
  Stack,
  IconButton,
  Grid,
  Paper,
} from '@material-ui/core'
import { TipsAndUpdates as TipsAndUpdatesIcon, Close as CloseIcon } from '@mui/icons-material'
import { fDateTime } from 'src/utils/formatTime'

const sectionBoxStyle = {
  backgroundColor: 'rgba(255, 255, 255, 0.03)',
  borderRadius: '12px',
  padding: '24px',
  marginBottom: '24px',
  border: '1px solid rgba(255, 255, 255, 0.05)',
  backdropFilter: 'blur(8px)',
}

const sectionHeaderStyle = {
  marginTop: 0,
  marginBottom: '18px',
  color: '#00e676',
  fontSize: '1.1rem',
  fontWeight: 500,
  letterSpacing: '0.05em',
}

const ReadOnlyAnnotationDialog = ({ open, onClose, ai }) => {
  if (!ai) return null
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1}>
            <TipsAndUpdatesIcon color="primary" />
            <Typography variant="h6" component="span">
              AI Annotation Details
            </Typography>
          </Stack>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers sx={{ background: '#1a2035', color: '#fff', p: 4 }}>
        {/* Clinical Information Section */}
        <Box sx={sectionBoxStyle}>
          <Typography sx={sectionHeaderStyle}>Clinical Information</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="textSecondary">
                Clinical History
              </Typography>
              <Typography sx={{ mb: 2 }}>{ai.clinical_history || <i>Not provided</i>}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="textSecondary">
                User Guidance
              </Typography>
              <Typography sx={{ mb: 2 }}>{ai.user_guidance || <i>Not provided</i>}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="textSecondary">
                Diseases
              </Typography>
              {ai.diseases && ai.diseases.length > 0 ? (
                ai.diseases.map((d, i) => <Chip key={i} label={d} sx={{ mr: 1, mb: 1 }} />)
              ) : (
                <Typography variant="body2" color="textSecondary">
                  <i>None</i>
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="textSecondary">
                HPO Names
              </Typography>
              {ai.hpo_names && ai.hpo_names.length > 0 ? (
                ai.hpo_names.map((h, i) => <Chip key={i} label={h} sx={{ mr: 1, mb: 1 }} />)
              ) : (
                <Typography variant="body2" color="textSecondary">
                  <i>None</i>
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="textSecondary">
                HPO IDs
              </Typography>
              {ai.hpos && ai.hpos.length > 0 ? (
                ai.hpos.map((h, i) => <Chip key={i} label={h} sx={{ mr: 1, mb: 1 }} />)
              ) : (
                <Typography variant="body2" color="textSecondary">
                  <i>None</i>
                </Typography>
              )}
            </Grid>
          </Grid>
        </Box>
        {/* Type Section */}
        <Box sx={sectionBoxStyle}>
          <Typography sx={sectionHeaderStyle}>Type</Typography>
          <Stack direction="row" spacing={2}>
            <Chip label={`CNV: ${ai.is_cnv ? 'Yes' : 'No'}`} color={ai.is_cnv ? 'primary' : 'default'} />
            <Chip label={`SNP: ${ai.is_snp ? 'Yes' : 'No'}`} color={ai.is_snp ? 'primary' : 'default'} />
          </Stack>
        </Box>
        <Divider sx={{ my: 2, borderColor: 'rgba(255,255,255,0.1)' }} />
        <Box mt={2}>
          <Typography variant="caption" color="textSecondary">
            Last updated by: {ai.person} on {ai.updated_at ? fDateTime(ai.updated_at) : 'N/A'}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default ReadOnlyAnnotationDialog
